import {
  defaultShouldDehydrateQuery,
  isServer,
  QueryClient,
} from '@tanstack/react-query'
import { HTTPError } from 'ky'
import { toast } from 'sonner'

let displayedNetworkFailureError = false
let browserQueryClient: QueryClient | undefined = undefined

function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry(failureCount) {
          if (failureCount >= 3) {
            if (!isServer && !displayedNetworkFailureError) {
              displayedNetworkFailureError = true

              toast.error(
                'A aplicação está demorando mais que o esperado para carregar, tente novamente em alguns minutos.',
                {
                  onDismiss: () => {
                    displayedNetworkFailureError = false
                  },
                },
              )
            }

            return false
          }

          return true
        },
      },
      mutations: {
        async onError(error) {
          if (!isServer && error instanceof HTTPError) {
            try {
              const status = error.response.status
              const data = await error.response.json()
              const message = data?.message || 'Ocorreu um erro inesperado.'
              const errors = data?.errors // validações

              // Exibe mensagens de erro múltiplas, se existirem
              if (errors && typeof errors === 'object') {
                Object.values(errors).forEach((errGroup) => {
                  if (Array.isArray(errGroup)) {
                    errGroup.forEach((msg) => {
                      toast.error(msg)
                    })
                  }
                })
                return
              }

              // Tratamento por status HTTP
              switch (status) {
                case 400:
                  toast.error(message || 'Requisição inválida.')
                  break
                case 401:
                  toast.error('Você precisa estar autenticado para continuar.')
                  break
                case 403:
                  toast.error('Você não tem permissão para realizar essa ação.')
                  break
                case 404:
                  toast.error('Recurso não encontrado.')
                  break
                case 422:
                  toast.error(message || 'Dados inválidos enviados.')
                  break
                case 500:
                  toast.error(
                    'Erro interno no servidor. Tente novamente mais tarde.',
                  )
                  break
                default:
                  toast.error(message)
              }
            } catch {
              toast.error('Erro ao processar a resposta do servidor.')
            }
          }
        },
      },
      dehydrate: {
        shouldDehydrateQuery: (query) =>
          defaultShouldDehydrateQuery(query) ||
          query.state.status === 'pending',
      },
    },
  })
}

export function getQueryClient() {
  if (isServer) {
    return makeQueryClient()
  } else {
    if (!browserQueryClient) browserQueryClient = makeQueryClient()
    return browserQueryClient
  }
}
